import React from 'react';
import { Search, Inbox, AlertOctagon } from 'lucide-react';
import { motion } from 'framer-motion';

export const EmptyState = ({ 
  icon: Icon = Search, 
  title = "No encontramos resultados", 
  message = "Probá cambiando los filtros o buscando algo más general.",
  actionLabel,
  onAction
}) => {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '5rem 2rem', 
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.02)',
        borderRadius: '2rem',
        border: '1px dashed rgba(255, 255, 255, 0.1)',
        width: '100%',
        margin: '2rem 0'
      }}
    >
      <div style={{ 
        width: '80px', 
        height: '80px', 
        borderRadius: '24px', 
        background: 'rgba(var(--primary-rgb), 0.1)', 
        display: 'grid', 
        placeItems: 'center', 
        marginBottom: '1.5rem',
        border: '1px solid rgba(var(--primary-rgb), 0.2)'
      }}>
        <Icon size={40} color="var(--primary)" />
      </div>
      <h3 style={{ fontSize: '1.5rem', marginBottom: '0.75rem', fontWeight: 800 }}>{title}</h3>
      <p style={{ color: 'var(--text-muted)', maxWidth: '300px', lineHeight: 1.6, marginBottom: '2rem' }}>
        {message}
      </p>
      {actionLabel && (
        <button className="btn-primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </motion.div>
  );
};

export const ErrorState = ({ message, onRetry }) => (
  <EmptyState 
    icon={AlertOctagon}
    title="¡Ups! Algo salió mal"
    message={message || "Hubo un problema al cargar la información."}
    actionLabel="Reintentar"
    onAction={onRetry}
  />
);

export const NoMatchesState = ({ onAction }) => (
  <EmptyState 
    icon={Inbox}
    title="Sin partidos recientes"
    message="Todavía no hay partidos reportados. ¡Sé el primero en reportar uno!"
    actionLabel="Reportar Partido"
    onAction={onAction}
  />
);
